import { assign } from 'lodash';
import { useLayoutEffect, useRef } from 'react';
import { getInjector } from '../../../angular-injector-holder';

/**
 * @param {string} name - service name
 */
export function getAngularServiceWeak(name) {
    const injector = getInjector();
    try {
        return injector?.get(name);
    } catch {
        return null;
    }
}

export function getAngularService(moduleGetter, name) {
    return import(/* webpackChunkName: 'AngularModule' */ '../../../module').then(({ $injector }) =>
        moduleGetter().then(m => {
            $injector.loadNewModules([m.default]);
            return name && $injector.get(name);
        })
    );
}

const compileElement = scopeProps => element => {
    if (element) {
        const $compile = getAngularServiceWeak('$compile');
        const $rootScope = getAngularServiceWeak('$rootScope');
        if (element.__scope) {
            assign(element.__scope, { $ctrl: scopeProps });
        } else {
            const scope = assign($rootScope.$new(), { $ctrl: scopeProps });
            $compile(element)(scope);
            element.__scope = scope;
        }
        if (!element.__scope.$$phase) {
            element.__scope.$digest();
        }
    }
    return element;
};

export function compileAngular(template, scopeProps) {
    return <AngularCompiler template={template} scopeProps={scopeProps} />;
}

function AngularCompiler({ scopeProps, template }) {
    const elementRef = useRef();
    const angularElementRef = useRef();

    useLayoutEffect(() => {
        if (elementRef.current) {
            elementRef.current.innerHTML = template;
        }
    }, [template]);

    useLayoutEffect(() => {
        angularElementRef.current = compileElement(scopeProps)(elementRef.current);
    }, [scopeProps]);

    useLayoutEffect(
        () => () => {
            angularElementRef.current?.__scope?.$destroy?.();
        },
        []
    );

    return <div ref={elementRef} />;
}
